import Certificates from 'components/Certificates';
import Course from 'components/Course';
import Showcase from 'components/Courses';
import Help from 'components/Help';
import Lesson from 'components/Lesson';
import Login from 'components/Login';
import Profile from 'components/Profile';
import Toast from 'components/Shared/Toast';
import { PureComponent } from 'react';
import FabricaDeProvasPage from 'components/FabricaDeProvasPage';
import Forum from 'components/Forum';
import Terms from '../Terms/index';
import AppRecomendation from 'components/Shared/AppRecomendation';
import { isMobile } from 'utils';
import { ThemeProvider } from '@material-ui/core';
import HoustonProvider from '@eduzz/houston-ui/styles/ThemeProvider';
import defaultTheme from 'assets/themes/defaultTheme';
import houston from 'assets/themes/Houston';
import Invite from '../Invite';
import Notifications from 'components/Notifications';
import Admin from '../Admin';
import SavedLesson from 'components/SavedLesson';
import Content from 'components/Content';
import palette from 'assets/themes/Houston/palette';
import Unsubscribe from 'components/UnsubscribePage';

class Pages extends PureComponent<any> {
  static routes = [
    {
      path: '/conteudo/:courseHash/:lessonId?',
      exact: true,
      component: Content,
      redirect: '/vitrine',
      allowAnonymous: true,
    },
    {
      path: '/convite/:courseHash/:id',
      exact: true,
      allowAnonymous: true,
      component: Invite,
      redirect: '/vitrine',
    },
    {
      path: '/admin/:producer(\\d+)/:hash(.{8,})',
      exact: true,
      component: Admin,
      redirect: '/',
      allowAnonymous: true,
    },
    {
      path: '/vitrine',
      exact: true,
      component: Showcase,
      redirect: '/',
    },
    {
      path: '/curso/:courseHash/:courseSlug?',
      exact: true,
      component: Course,
      redirect: '/',
      allowAnonymous: true,
    },
    {
      path: '/curso/:courseHash/:courseSlug?/aula/:lessonID',
      exact: true,
      component: Lesson,
      redirect: '/',
      allowAnonymous: true,
    },
    {
      path: '/curso/:courseHash/:courseSlug?/aula/:lessonID/forum/:topicID',
      exact: true,
      component: Forum,
      redirect: '/',
    },
    {
      path: '/curso/:courseHash/:courseSlug?/aula/:lessonID/:lessonContentId',
      exact: true,
      component: FabricaDeProvasPage,
      redirect: '/',
      allowAnonymous: false,
    },
    {
      path: '/certificados',
      exact: true,
      component: Certificates,
      redirect: '/',
    },
    {
      path: '/perfil',
      exact: true,
      component: Profile,
      redirect: '/',
    },
    {
      path: '/ajuda',
      exact: true,
      component: Help,
      allowAnonymous: true,
      redirect: '/',
    },
    {
      path: '/termos',
      exact: true,
      component: Terms,
      allowAnonymous: true,
      redirect: '/',
    },
    {
      path: '/notificacoes',
      exact: true,
      allowAnonymous: false,
      component: Notifications,
      redirect: '/',
    },
    {
      path: '/unsubscribe/:trackId',
      exact: true,
      allowAnonymous: true,
      component: Unsubscribe,
      blankPage: true,
    },
    {
      path: '/aulas/salvas',
      newLayout: true,
      exact: true,
      component: SavedLesson,
      redirect: '/',
    },
    {
      path: '/',
      exact: false,
      allowAnonymous: true,
      component: Login,
    },
  ];

  render() {
    return (
      <ThemeProvider theme={defaultTheme}>
        <HoustonProvider palette={palette as any}>
          <ThemeProvider theme={houston}>
            <Toast />
            {isMobile.any() && <AppRecomendation />}
            {this.props.children}
          </ThemeProvider>
        </HoustonProvider>
      </ThemeProvider>
    );
  }
}

export default Pages;
